import PropTypes from 'prop-types';
import IssueShape from './IssueShape';

export default PropTypes.shape({
  LOAN_NOT_IN_SYSTEM: PropTypes.arrayOf(IssueShape),
});
